import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  TextField,
  Button,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const ContactUs = () => {
  return (
    <Box>
      {/* ================= HERO ================= */}
      <Box
        sx={{
          height: "45vh",
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.65)), url('/contact.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: "#fff",
            fontWeight: 900,
            letterSpacing: "0.04em",
          }}
        >
          Contact Us
        </Typography>
      </Box>

      {/* ================= CONTENT ================= */}
      <Box sx={{ py: 10, px: 4, backgroundColor: "#f8fafc" }}>
        <Grid container spacing={6} maxWidth="1200px" mx="auto">

          {/* ================= LEFT FORM ================= */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                p: 5,
                borderRadius: 4,
                height: "100%",
                boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
              }}
            >
              <Typography variant="h4" fontWeight={800} mb={1}>
                Get in Touch
              </Typography>
              <Typography mb={4} color="text.secondary">
                You can reach us anytime
              </Typography>

              <Grid container spacing={3} direction="column">
                <Grid item>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField fullWidth label="First Name" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField fullWidth label="Last Name" />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item>
                  <TextField fullWidth label="Email" />
                </Grid>

                <Grid item>
                  <TextField fullWidth label="Phone Number" />
                </Grid>

                <Grid item>
                  <TextField
                    fullWidth
                    label="Message"
                    multiline
                    rows={4}
                  />
                </Grid>

                <Grid item>
                  <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    sx={{
                      py: 1.6,
                      fontWeight: 700,
                      backgroundColor: "#1e3a8a",
                      "&:hover": {
                        backgroundColor: "#1e40af",
                      },
                    }}
                  >
                    Submit Message
                  </Button>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* ================= RIGHT INFO + MAP ================= */}
          <Grid item xs={12} md={6}>

            {/* INFO CARDS */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    height: "100%",
                    boxShadow: "0 12px 30px rgba(0,0,0,0.06)",
                  }}
                >
                  <Box display="flex" alignItems="center" mb={1.5}>
                    <LocationOnIcon sx={{ color: "#1e3a8a", mr: 1 }} />
                    <Typography fontWeight={700}>
                      Office Address
                    </Typography>
                  </Box>
                  <Typography color="text.secondary" lineHeight={1.8}>
                    Flat No: 4-10/3
                    Nagaram Road<br />
                    Hyderabad – 500083<br />
                    Telangana
                  </Typography>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    height: "100%",
                    boxShadow: "0 12px 30px rgba(0,0,0,0.06)",
                  }}
                >
                  <Box display="flex" alignItems="center" mb={1.5}>
                    <PhoneIcon sx={{ color: "#1e3a8a", mr: 1 }} />
                    <Typography fontWeight={700}>
                      Contact Details
                    </Typography>
                  </Box>
                  <Typography color="text.secondary" lineHeight={1.9}>
                    <EmailIcon sx={{ fontSize: 16, mr: 1 }} />
                    admin@anaghaengineers.com
                    <br />
                    <PhoneIcon sx={{ fontSize: 16, mr: 1 }} />
                    +91 9505474849
                  </Typography>
                </Card>
              </Grid>
            </Grid>

            {/* MAP */}
            <Box sx={{ mt: 4 }}>
              <Card
                sx={{
                  height: 418,
                  borderRadius: 4,
                  overflow: "hidden",
                  boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
                }}
              >
                <iframe
                  title="Anagha Engineers Location"
                  src="https://www.google.com/maps?cid=0&ll=17.4965463,78.6054438&z=18&t=k&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                />
              </Card>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ContactUs;
